import {
  COMPARISON_OPERATORS,
  FILTER_TYPES,
} from '@witmetrics/utils/constants';
import { API } from '@/api';

export const classes = {
  paper: 'fixed top-8 rounded-2xl',
  wrapper: 'flex flex-col w-[90vw] max-w-[900px] min-w-[200px] min-h-0',
  inputBase: 'w-full text-2xl px-6 py-4 flex-0',
  recentlyViewedWrapper: 'place-between px-6 py-0',
  recentlyViewed: 'text-base text-grey-8 dark:text-mauve-1 font-medium',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto',
  recentList: 'pt-0 mt-0',
};

export async function fetchMatchingOrders(labId: number, search: string) {
  const timestamp = Date.now();
  const { results } = await API.Labs.fetchLabOrders(labId, {
    search,
    filters: [],
    pagination: { page: 1, pageSize: 20 },
  });
  return { timestamp, orders: results };
}

export async function fetchRecentOrders(labId: number, orderIds: number[]) {
  const { results } = await API.Labs.fetchLabOrders(labId, {
    pagination: { page: 1, pageSize: 5 },
    filters: [
      {
        filterType: FILTER_TYPES.COLUMN_VALUE,
        column: 'id',
        comparisonOperator: COMPARISON_OPERATORS.IN.value,
        value: orderIds,
      },
    ],
  });
  if (!results) return [];
  // Match the original orderIds order
  return results.sort(
    (a, b) => orderIds.indexOf(a.id) - orderIds.indexOf(b.id)
  );
}
